<div class="modal-header">
  <h4 class="modal-title">Game Log</h4>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body p-3">
  <!-- Filters -->
  <div class="d-flex flex-row flex-wrap gap-2 align-items-end mb-3">
    <div>
      <label class="form-label mb-1">Date From</label>
      <input type="datetime-local" class="form-control form-control-sm" [(ngModel)]="data.date_from" />
    </div>
    <div>
      <label class="form-label mb-1">Date To</label>
      <input type="datetime-local" class="form-control form-control-sm" [(ngModel)]="data.date_to" />
    </div>
    <div>
      <label class="form-label mb-1">Player Code</label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="data.code" />
    </div>
    <div>
      <label class="form-label mb-1">Match</label>
      <select class="form-select form-select-sm" [(ngModel)]="data.match">
        <option value="exact">Exact</option>
        <option value="approx">Approximate</option>
      </select>
    </div>
    <div style="min-width:180px">
      <label class="form-label mb-1">Game</label>
      <ng-select
        bindLabel="name"
        bindValue="id"
        [items]="games"
        [multiple]="true"
        [clearable]="true"
        placeholder="All Games"
        [(ngModel)]="data.game_id">
      </ng-select>
    </div>
    <button class="btn btn-primary btn-sm" (click)="filter()">Filter</button>
  </div>

  <!-- Statistic -->
  <div class="d-flex flex-row flex-wrap gap-2 mb-3" *ngIf="!load && items.length > 0">
    <span class="badge bg-secondary">Records: {{statistic.total ?? 0}}</span>
    <span class="badge bg-primary">Bet: {{statistic.total_bet ?? 0 | number:'1.2-2'}}</span>
    <span class="badge bg-warning text-dark">Win: {{statistic.total_winloss ?? 0 | number:'1.2-2'}}</span>
    <span class="badge bg-danger">Loss: {{statistic.total_loss ?? 0 | number:'1.2-2'}}</span>
    <span class="badge bg-success">Bonus: {{statistic.total_bonus ?? 0 | number:'1.2-2'}}</span>
    <nav>
      <ul class="pagination pagination-sm mb-0">
        <li class="page-item"><a class="page-link" (click)="filter(page_nat.current_page - 1)" *ngIf="page_nat.current_page - 1 >= 0">&lt;</a></li>
        <li class="page-item" *ngFor="let page of page_nat.page_nat" [class.active]="page_nat.current_page + 1 == page">
          <a class="page-link" (click)="filter(page)">{{page}}</a>
        </li>
        <li class="page-item"><a class="page-link" (click)="filter(page_nat.current_page + 2)" *ngIf="page_nat.current_page + 2 <= page_nat.total_page">&gt;</a></li>
      </ul>
    </nav>
  </div>

  <!-- Loading -->
  <div class="text-center py-4" *ngIf="load">
    <div class="spinner-border"></div>
  </div>

  <!-- No Data -->
  <div *ngIf="!load && items.length === 0">
    <p class="text-muted">No data available.</p>
  </div>

  <!-- Table -->
  <div class="table-responsive" *ngIf="!load && items.length > 0">
    <table class="table table-sm table-striped mb-0" style="font-size:11px">
      <thead>
        <tr>
          <th>#</th>
          <th>Player</th>
          <th>Mobile</th>
          <th>Game</th>
          <th>Game Name</th>
          <th>Match / Event</th>
          <th>Txn ID</th>
          <th>Round ID</th>
          <th class="text-end">Bet</th>
          <th class="text-end">Winloss</th>
          <th class="text-end">Bonus</th>
          <th class="text-end">Balance After</th>
          <th>Status</th>
          <th>Created On</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of items; let i = index">
        <tr [class.bg-warning]="item.winloss > 0 && item.bet > 0"
            [class.bg-danger]="item.winloss > 0 && item.bet == 0"
            [class.text-white]="item.winloss > 0 && item.bet == 0">
          <td>{{(page_nat.current_page ?? 0) * (page_nat.page_limit ?? 200) + (i + 1)}}</td>
          <td>{{item.code}}</td>
          <td>{{item.mobile}}</td>
          <td>{{item.game_name}}{{item.platform ? ' (' + item.platform + ')' : ''}}</td>
          <td>{{item.supplier_game_name}}</td>
          <td>
            <ng-container *ngIf="hasDetail(item); else noMatchP">
              <span class="gl-match" (click)="toggleExpand(item)" title="Click to view all selections" style="cursor:pointer">
                <span class="gl-caret">{{ isExpanded(item) ? '▾' : '▸' }}</span>
                {{ matchSummary(item) }}
              </span>
            </ng-container>
            <ng-template #noMatchP><span class="text-muted">—</span></ng-template>
          </td>
          <td style="font-size:8px;width:80px">{{item.transaction_id}}</td>
          <td style="font-size:8px;width:80px">{{item.round_id}}</td>
          <td class="text-end">{{item.bet}}</td>
          <td class="text-end">{{item.winloss}}</td>
          <td class="text-end">{{item.bonus}}</td>
          <td class="text-end">{{item.wallet_balance | number:'1.2-2'}}</td>
          <td>{{statusUpdate(item.status)}}</td>
          <td>{{item.create_on | date:'dd-MM-yyyy HH:mm:ss'}}</td>
        </tr>
        <tr *ngIf="hasDetail(item) && isExpanded(item)" class="gl-detail-row">
          <td colspan="14">
            <div class="gl-detail">
              <div class="gl-detail-head">
                {{ item.game_detail.sportName }}
                <span *ngIf="item.game_detail.betType"> · {{ item.game_detail.betType }}</span>
                <span *ngIf="item.game_detail.totalOdds"> · total odds {{ item.game_detail.totalOdds }}</span>
                <span *ngIf="item.game_detail.legs.length > 1"> · {{ item.game_detail.legs.length }} legs (parlay)</span>
              </div>
              <div class="gl-leg" *ngFor="let leg of item.game_detail.legs">
                <div class="gl-leg-event">
                  <span class="text-muted" *ngIf="leg.leagueName">{{ leg.leagueName }} · </span>
                  <span class="fw-semibold">{{ leg.eventName || (leg.homeTeam + ' vs ' + leg.awayTeam) }}</span>
                  <span class="badge bg-danger ms-1" *ngIf="leg.live">LIVE</span>
                  <span class="text-muted ms-1" *ngIf="leg.liveScore">({{ leg.liveScore }})</span>
                </div>
                <div class="gl-leg-sel">
                  {{ legSelection(leg) }}
                  <span class="ms-2" [ngClass]="legResultClass(leg)" *ngIf="leg.legStatus">[{{ leg.legStatus }}]</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </ng-container>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="8" class="text-end fw-bold">Total</td>
          <td class="text-end fw-bold">{{sum('bet') | number:'1.2-2'}}</td>
          <td class="text-end fw-bold">{{sum('winloss') | number:'1.2-2'}}</td>
          <td class="text-end fw-bold">{{sum('bonus') | number:'1.2-2'}}</td>
          <td colspan="3"></td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
